import { render, staticRenderFns } from "./index.vue?vue&type=template&id=8da32bc0&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JG\\jg\\IWMS5.0\\SRM\\GIT\\SRM.VUE\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8da32bc0')) {
      api.createRecord('8da32bc0', component.options)
    } else {
      api.reload('8da32bc0', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=8da32bc0&", function () {
      api.rerender('8da32bc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/demo/playground/frame/d2-doc/index.vue"
export default component.exports